import { ActionReducerMap } from '@ngrx/store';
import { AgentCustomReducers } from '../services/AgentCustom/store/agentCustom.reducers';
import { OrganizationReducers } from '../services/Organization/store/organization.reducers';
import { OrganizationUserReducers } from '../services/OrganizationUser/store/organizationUser.reducers';
import { GroupReducers } from '../services/Group/store/group.reducers';
import { ProjectReducers } from '../services/Project/store/project.reducers';
import { CustomFieldReducers } from '../services/CustomField/store/customField.reducers';
import { DiscussionReducers } from '../services/Discussion/store/discussion.reducers';
import { DiscussionActivityReducers } from '../services/DiscussionActivity/store/discussionActivity.reducers';
import { DocReducers } from '../services/Doc/store/doc.reducers';
import { ViewReducers } from '../services/View/store/view.reducers';
import { TaskReducers } from '../services/Task/store/tasklist/task.reducers';
import { ChatChannelReducers } from '../services/Chat/store/channel/channel.reducers';
import { ChatMessageReducers } from '../services/Chat/store/message/message.reducers';
import { CallUserConfigReducers } from '../services/CRM/CallConfig/store/config.reducers';
import { CallReducers } from '../services/CRM/Call/store/call.reducers';
import { ContactReducers } from '../services/CRM/Contact/store/contact.reducers';
import { ContactViewReducers } from '../services/CRM/View/store/contactView.reducers';
import { FileViewReducers } from '../services/File/store/fileView.reducers';
import { SessionReducers } from '../services/Session/store/session.reducers';
import { PortfolioReducers } from '../services/Portfolio/store/portfolio.reducers';
import { PortfolioProjectReducers } from '../services/PortfolioProject/store/portfolioProject.reducers';
import { recordActivityReducers } from '../services/Record/store/recordActivity.reducers';
import { ReportReducers } from '../services/Report/Core/store/report.reducers';
import { ReportCardReducers } from '../services/Report/Card/store/card.reducers';
import { TaskQueueReducers } from '../services/Task/store/queue/taskQueue.reducers';
import { TimelogReducers } from '../services/TimeTracking/store/timelog.reducers';
import { NotificationReducers } from '../services/Notification/store/notification.reducers';
import { OrganizationJobRoleReducers } from '../services/Resource/jobRole/store/organizationJobRole.reducers';
import { HolidayReducers } from '../services/Resource/holiday/store/organizationHoliday.reducers';
import { OutOfOfficeReducers } from '../services/Resource/out-of-office/store/outOfOffice.reducers';
import { MembershipReducers } from '../services/Membership/store/membership.reducers';
import { FormReducers } from '../services/Form/store/form/form.reducers';
import { FormElementReducers } from '../services/Form/store/element/formElement.reducers';
import { EmailUserConfigReducers } from '../services/Integrations/Email/config/store/email-config.reducers';
import { EmailMessageTemplateReducers } from '../services/Integrations/Email/templates/store/email-template.reducers';
import { BlogReducers } from '../services/Blog/store/blog.reducers';
import { MetaConfigReducers } from '../services/Integrations/Meta/config/store/metaConfig.reducers';
import { MetaConvConfigReducers } from '../services/Integrations/Meta/conv/store/metaConvConfig.reducers';
import { MetaWhatsAppConfigReducers } from '../services/Integrations/Meta/WhatsApp/store/metaWhatsAppConfig.reducers';
import { ExtAuthConfigReducers } from '../services/Integrations/Auth/store/extAuth.reducers';
import { ExtCalendlyConfigReducers } from '../services/Integrations/Calendly/store/extCalendly.reducers';
import { ExtIndiamartConfigReducers } from '../services/Integrations/Indiamart/store/extIndiamart.reducers';
import { ExtJiraConfigReducers } from '../services/Integrations/Jira/config/store/extJira.reducers';
import { CustomerStoryReducers } from '../services/Prismic/CustomerStories/store/customerStories.reducers';
import { karmaActivityReducers } from '../services/Karma/Activity/store/karmaActivity.reducers';
import { karmaRewardReducers } from '../services/Karma/Reward/store/karmaReward.reducers';
import { WorkflowReducers } from '../services/Workflow/core/store/workflow.reducers';
import { WorkflowNodeReducers } from '../services/Workflow/node/store/workflow-node.reducers';

export const reducers: ActionReducerMap<any> = {
    agentCustom: AgentCustomReducers,

    call: CallReducers,
    callUserConfig: CallUserConfigReducers,

    contact: ContactReducers,
    contactView: ContactViewReducers,

    chatChannel: ChatChannelReducers,
    chatMessage: ChatMessageReducers,

    customField: CustomFieldReducers,

    discussion: DiscussionReducers,
    discussionActivity: DiscussionActivityReducers,

    doc: DocReducers,

    emailUserConfig: EmailUserConfigReducers,
    emailMessageTemplate: EmailMessageTemplateReducers,

    extAuthConfig: ExtAuthConfigReducers,
    extCalendlyConfig: ExtCalendlyConfigReducers,
    extIndiamartConfig: ExtIndiamartConfigReducers,
    extJiraConfig: ExtJiraConfigReducers,

    fileView: FileViewReducers,

    form: FormReducers,
    formElement: FormElementReducers,

    group: GroupReducers,

    holiday: HolidayReducers,

    karmaActivity: karmaActivityReducers,
    karmaReward: karmaRewardReducers,

    membership: MembershipReducers,
    metaConfig: MetaConfigReducers,
    metaConvConfig: MetaConvConfigReducers,
    metaWhatsAppConfig: MetaWhatsAppConfigReducers,

    notification: NotificationReducers,

    portfolio: PortfolioReducers,
    portfolioProject: PortfolioProjectReducers,

    project: ProjectReducers,

    organization: OrganizationReducers,
    organizationUser: OrganizationUserReducers,
    organizationJobRole: OrganizationJobRoleReducers,
    ooo: OutOfOfficeReducers,

    recordActivity: recordActivityReducers,

    report: ReportReducers,
    reportCard: ReportCardReducers,

    session: SessionReducers,

    task: TaskReducers,
    taskQueue: TaskQueueReducers,

    timelog: TimelogReducers,

    view: ViewReducers,

    workflow: WorkflowReducers,
    workflowNode: WorkflowNodeReducers,

    blog: BlogReducers,
    customerStory: CustomerStoryReducers,
};
